// extracted by mini-css-extract-plugin
export default {"nextb":"ap_nextb__uKoK3","loader":"ap_loader__aAiCF","l3":"ap_l3__bF4E+","ap":"ap_ap__e9X7g","text":"ap_text__ha11m","s":"ap_s__tTiTa"};